import { USER_AGREEMENT_LINK_COUNTRIES } from 'shared/shared_consts'

export function getMoneyPoolTNCLink(paypalDomain, countryCode) {
  const base_url = `https://${paypalDomain}/${countryCode}/webapps/mpp/ua/`
  if (USER_AGREEMENT_LINK_COUNTRIES.indexOf(countryCode) > -1) {
    return `${base_url}useragreement-full`
  } else {
    return `${base_url}moneypool-tnc`
  }
}
